(function () {
  if (window.__idmSearchEnhanceInit) return;
  window.__idmSearchEnhanceInit = true;
  var IDM_GIF_VIDE = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
  var idmPreSuggestImagesReady = false;
  function parsePreSuggestTemplate() {
    var t = document.getElementById('idm-pre-suggest-template');
    if (!t) return { fragment: null, cards: [], rawLength: 0 };
    var html = t.textContent || t.innerHTML || '';
    var temp = null;
    if (!idmPreSuggestImagesReady) {
      try { temp = document.implementation.createHTMLDocument('').createElement('div'); } catch (e) { temp = null; }
    }
    if (!temp) temp = document.createElement('div');
    temp.innerHTML = html;
    if (!idmPreSuggestImagesReady) {
      var ph = temp.querySelectorAll('img');
      for (var p = 0; p < ph.length; p += 1) {
        var s0 = ph[p].getAttribute('src');
        if (s0 && s0.indexOf('data:') !== 0) {
          ph[p].setAttribute('data-idm-ph', s0);
          ph[p].setAttribute('src', IDM_GIF_VIDE);
        }
        if (ph[p].classList.contains('lazyload')) { ph[p].classList.remove('lazyload'); ph[p].setAttribute('data-idm-lz', '1'); }
      }
    }
    var cards = temp.querySelectorAll('.idm-search-slider__item');
    return { fragment: temp, cards: cards, rawLength: html.length };
  }
  var idmPreSuggestLoaded = false;
  var idmPreSuggestLoading = false;
  var idmPreSuggestAttente = [];
  function idmLoadPreSuggest(cb) {
    if (idmPreSuggestLoaded) { if (cb) { cb(); } return; }
    if (cb) { idmPreSuggestAttente.push(cb); }
    if (idmPreSuggestLoading) { return; }
    idmPreSuggestLoading = true;
    var root = window.__IDM_SEARCH_ROOT__ || '/';
    fetch(root + '?sections=idm-search-presuggest', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = (j && j['idm-search-presuggest']) || '';
        var t = document.getElementById('idm-pre-suggest-template');
        if (t && html) {
          t.textContent = html;
          idmPreSuggestLoaded = true;
        }
        idmPreSuggestLoading = false;
        var l = idmPreSuggestAttente.splice(0);
        if (idmPreSuggestLoaded) { for (var i = 0; i < l.length; i += 1) { l[i](); } }
      })
      .catch(function () { idmPreSuggestLoading = false; idmPreSuggestAttente.length = 0; });
  }
  (function () {
    var icon = document.getElementById('search-icon');
    if (!icon) { return; }
    var warm = function () { idmLoadPreSuggest(function () { showPreSuggest(); }); idmPreSuggestActivate(); };
    icon.addEventListener('pointerdown', warm, { once: true, passive: true });
    icon.addEventListener('touchstart', warm, { once: true, passive: true });
    icon.addEventListener('mouseenter', warm, { once: true, passive: true });
    icon.addEventListener('focus', warm, { once: true, passive: true });
    icon.addEventListener('click', warm, { once: true, passive: true });
  })();
  var DEBOUNCE_MS = 250;
  function getAjax() { return document.querySelector('.search-ajax'); }
  function getInput() { return document.querySelector('#search-input, .search-field'); }
  function escapeRegex(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function escapeHtml(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }
  function highlightInElement(el, query) {
    if (!el || !query || query.length < 2) return;
    var text = el.textContent;
    if (!text) return;
    var re = new RegExp('(' + escapeRegex(query) + ')', 'gi');
    var html = '';
    var lastIdx = 0;
    var match;
    while ((match = re.exec(text)) !== null) {
      html += escapeHtml(text.slice(lastIdx, match.index));
      html += '<mark class="idm-search-hl">' + escapeHtml(match[0]) + '</mark>';
      lastIdx = match.index + match[0].length;
      if (match.index === re.lastIndex) re.lastIndex += 1;
    }
    html += escapeHtml(text.slice(lastIdx));
    el.innerHTML = html;
  }
  function extractHandleFromHref(href) {
    if (!href) return '';
    var m = href.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }
  function activateImages(container) {
    var imgs = container.querySelectorAll('img.lazyload, img[data-src], img[data-srcset]:not(.idm-photo-couleur)');
    var count = 0;
    for (var i = 0; i < imgs.length; i += 1) {
      var img = imgs[i];
      var srcset = img.getAttribute('data-srcset');
      var src = img.getAttribute('data-src');
      var sizes = img.getAttribute('data-sizes');
      if (sizes) img.setAttribute('sizes', sizes);
      if (srcset) img.setAttribute('srcset', srcset);
      if (src) img.setAttribute('src', src);
      img.classList.remove('lazyload');
      img.classList.add('lazyloaded');
      count += 1;
    }
    return imgs;
  }
  function idmPreSuggestActivate() {
    if (idmPreSuggestImagesReady) { return; }
    idmPreSuggestImagesReady = true;
    var ajax = getAjax();
    var pre = ajax && ajax.querySelector('.idm-pre-suggest');
    if (!pre) { return; }
    var ph = pre.querySelectorAll('img[data-idm-ph], img[data-idm-lz]');
    for (var i = 0; i < ph.length; i += 1) {
      if (ph[i].hasAttribute('data-idm-ph') && !ph[i].hasAttribute('data-src') && !ph[i].hasAttribute('data-srcset')) { ph[i].setAttribute('src', ph[i].getAttribute('data-idm-ph')); }
      if (ph[i].hasAttribute('data-idm-lz')) { ph[i].classList.add('lazyload'); }
      ph[i].removeAttribute('data-idm-ph');
      ph[i].removeAttribute('data-idm-lz');
    }
    activateImages(pre);
  }
  var CARDS_TARGET = 10;
  function applyDeprioritizeDom(cards) {
    var list = window.__IDM_SEARCH_DEPRIORITIZE__ || [];
    if (!list.length) {
      return Array.prototype.slice.call(cards, 0, CARDS_TARGET);
    }
    var deprio = {};
    for (var i = 0; i < list.length; i += 1) {
      var h = (list[i] || '').toString().trim().toLowerCase();
      if (h) deprio[h] = true;
    }
    var top = [];
    var bottom = [];
    var byHandle = [];
    for (var j = 0; j < cards.length; j += 1) {
      var raw = cards[j].getAttribute('href') || '';
      var handle = extractHandleFromHref(raw).toLowerCase();
      var hit = !!deprio[handle];
      byHandle.push({ pos: j + 1, handle: handle, href: raw, deprio: hit });
      if (hit) bottom.push(cards[j]);
      else top.push(cards[j]);
    }
    for (var k = 0; k < byHandle.length; k += 1) {
      var info = byHandle[k];
    }
    var final = top.slice(0, CARDS_TARGET);
    var fallbackUsed = 0;
    if (final.length < CARDS_TARGET) {
      var needed = CARDS_TARGET - final.length;
      var fallback = bottom.slice(0, needed);
      final = final.concat(fallback);
      fallbackUsed = fallback.length;
    }
    var droppedDeprio = Math.max(0, bottom.length - fallbackUsed);
    return final;
  }
  var lastQuery = '';
  var fetchController = null;
  function buildFetchUrl(query) {
    var prefix = (window.__IDM_SEARCH_ROOT__ && window.__IDM_SEARCH_ROOT__ !== '/') ? window.__IDM_SEARCH_ROOT__ : '';
    return prefix + '/search?view=ajax-suggest'
      + '&q=' + encodeURIComponent(query)
      + '&type=product'
      + '&options[unavailable_products]=last';
  }
  function fetchHtml(query) {
    if (fetchController) {
      try { fetchController.abort(); } catch (e) {}
    }
    fetchController = (typeof AbortController === 'function') ? new AbortController() : null;
    var url = buildFetchUrl(query);
    var t0 = performance.now();
    return fetch(url, {
      signal: fetchController ? fetchController.signal : undefined,
      headers: { 'Accept': 'text/html' }
    })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        return html;
      });
  }
  var lastRenderQuery = '';
  var renderTimer = null;
  var preSuggestVisible = false;
  function forceAjaxVisible() {
    var ajax = getAjax();
    if (!ajax) return;
    ajax.style.setProperty('display', 'block', 'important');
  }
  function dumpVisibilityChain() {
    var ajax = getAjax();
    if (!ajax) return;
    var p = ajax;
    var chain = [];
    var depth = 0;
    while (p && p !== document.body && depth < 10) {
      var cs = window.getComputedStyle(p);
      var rect = p.getBoundingClientRect();
      chain.push({
        depth: depth,
        el: (p.tagName || '?') + (p.className ? '.' + String(p.className).split(' ').slice(0,3).join('.') : ''),
        display: cs.display,
        visibility: cs.visibility,
        opacity: cs.opacity,
        w: Math.round(rect.width),
        h: Math.round(rect.height)
      });
      p = p.parentElement;
      depth += 1;
    }
  }
  function trackAjaxHeight(label) {
    var ajax = getAjax();
    if (!ajax) return;
    var current = ajax.offsetHeight;
    var modalContent = document.querySelector('.modal-search .modal-search-content');
    var modalH = modalContent ? modalContent.offsetHeight : 0;
    var lockedRaw = ajax.style.minHeight;
    var locked = parseInt(lockedRaw, 10) || 0;
    if (current > locked) {
      ajax.style.minHeight = current + 'px';
    } else {
    }
  }
  function unlockAjaxHeight() {
    var ajax = getAjax();
    if (!ajax) return;
    if (ajax.style.minHeight) {
      ajax.style.minHeight = '';
    }
  }
  function dumpModalSpacing(label) {
    function inspect(el, name) {
      if (!el) return { name: name, found: false };
      var r = el.getBoundingClientRect();
      var cs = window.getComputedStyle(el);
      return {
        name: name,
        found: true,
        top: Math.round(r.top),
        bottom: Math.round(r.bottom),
        height: Math.round(r.height),
        pTop: cs.paddingTop,
        pBot: cs.paddingBottom,
        mTop: cs.marginTop,
        mBot: cs.marginBottom,
        minH: cs.minHeight,
        maxH: cs.maxHeight,
        h: cs.height
      };
    }
    var modal = document.querySelector('.modal-search');
    var content = document.querySelector('.modal-search .modal-search-content');
    var container = document.querySelector('.modal-search .container');
    var ajax = document.querySelector('.search-ajax');
    var results = document.querySelector('.idm-search-results, .idm-pre-suggest, .idm-search-no-results, .idm-search-pending');
    var viewAll = document.querySelector('.idm-search-view-all');
    var btn = document.querySelector('.idm-search-view-all .index-button');
    var infoModal = inspect(modal, 'modal-search');
    var infoContent = inspect(content, 'modal-search-content');
    var infoContainer = inspect(container, 'container');
    var infoAjax = inspect(ajax, 'search-ajax');
    var infoResults = inspect(results, 'results-wrapper');
    var infoViewAll = inspect(viewAll, 'view-all-wrapper');
    var infoBtn = inspect(btn, 'view-all-button');
    if (infoBtn.found) {
      var btnBot = infoBtn.bottom;
      if (infoViewAll.found) {
      }
      if (infoResults.found) {
      }
      if (infoAjax.found) {
      }
      if (infoContainer.found) {
      }
      if (infoContent.found) {
      }
    }
  }
  function showLoadingState() {
    var ajax = getAjax();
    if (!ajax) return;
    forceAjaxVisible();
    var hasContent = ajax.querySelector('.idm-search-results')
      || ajax.querySelector('.idm-search-no-results')
      || ajax.querySelector('.idm-pre-suggest')
      || ajax.querySelector('.idm-search-pending');
    if (!hasContent) {
      ajax.innerHTML = '<div class="idm-search-pending"><div class="load-more-spinner" role="status" aria-label="Recherche en cours"></div></div>';
    } else {
    }
  }
  function scheduleRender(query) {
    if (renderTimer) clearTimeout(renderTimer);
    renderTimer = setTimeout(function () { doRender(query); }, DEBOUNCE_MS);
  }
  function doRender(query) {
    if (query.length < 2) { return; }
    var ajax = getAjax();
    if (!ajax) { return; }
    if (query === lastRenderQuery) {
      var stillRendered = ajax.querySelector('.idm-search-results')
        || ajax.querySelector('.idm-search-no-results');
      if (stillRendered) {
        return;
      }
      lastRenderQuery = '';
    }
    lastQuery = query;
    fetchHtml(query)
      .then(function (html) {
        var input = getInput();
        if (!input) { return; }
        var current = (input.value || '').trim();
        if (current !== query) {
          return;
        }
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var noResults = temp.querySelector('.idm-search-no-results');
        var rawCards = Array.prototype.slice.call(temp.querySelectorAll('.idm-search-slider__item'));
        var metaEl = temp.querySelector('.idm-search-meta');
        var totalResults = metaEl ? parseInt(metaEl.getAttribute('data-total'), 10) : NaN;
        if (isNaN(totalResults)) totalResults = rawCards.length;
        if (noResults || !rawCards.length) {
          ajax.innerHTML = '';
          if (noResults) {
            ajax.appendChild(noResults);
          } else {
            var idmTpl = window.__IDM_SEARCH_NO_RESULTS_TPL__ || '';
            var idmQ = '<strong>"' + escapeHtml(query) + '"</strong>';
            ajax.innerHTML = '<div class="idm-search-no-results">'
              + (idmTpl.indexOf('%Q%') !== -1 ? escapeHtml(idmTpl).replace('%Q%', idmQ) : escapeHtml(window.__IDM_SEARCH_NO_RESULTS_LABEL__ || 'Aucun résultat') + ' ' + idmQ)
              + '</div>';
          }
          lastRenderQuery = query;
          preSuggestVisible = false;
          return;
        }
        for (var k = 0; k < rawCards.length; k += 1) {
          var titleEl = rawCards[k].querySelector('.product-carousel-title');
          if (titleEl) highlightInElement(titleEl, query);
        }
        var ordered = applyDeprioritizeDom(rawCards);
        var wrapper = document.createElement('div');
        wrapper.className = 'idm-search-results';
        wrapper.innerHTML =
          '<div class="idm-search-slider">'
            + '<button class="idm-search-slider__prev" type="button" aria-label="' + ((window.__IDM_SEARCH_NAV_L__ || {}).prev || '') + '" hidden>'
              + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M 15.5 19 L 8.5 12 L 15.5 5"/></svg>'
            + '</button>'
            + '<button class="idm-search-slider__next" type="button" aria-label="' + ((window.__IDM_SEARCH_NAV_L__ || {}).next || '') + '" hidden>'
              + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M 8.5 19 L 15.5 12 L 8.5 5"/></svg>'
            + '</button>'
            + '<div class="idm-search-slider__nav"><div class="idm-search-slider__inner"></div></div>'
          + '</div>'
          + '<div class="idm-search-view-all">'
            + '<a class="index-button" href="' + ((window.__IDM_SEARCH_ROOT__ && window.__IDM_SEARCH_ROOT__ !== '/') ? window.__IDM_SEARCH_ROOT__ : '') + '/search?q=' + encodeURIComponent(query) + '&type=product">'
            + escapeHtml(
                (window.__IDM_SEARCH_VIEW_ALL_LABEL__ || 'Voir tous les {count} résultats')
                  .replace(/\{count\}/g, totalResults)
              )
            + '</a>'
          + '</div>';
        var inner = wrapper.querySelector('.idm-search-slider__inner');
        for (var m = 0; m < ordered.length; m += 1) inner.appendChild(ordered[m]);
        ajax.innerHTML = '';
        ajax.appendChild(wrapper);
        forceAjaxVisible();
        lastRenderQuery = query;
        preSuggestVisible = false;
        dumpVisibilityChain();
        var imgs = activateImages(wrapper);
        bindCarouselNav(ajax);
        function layoutPass(reason) {
          positionButtons(ajax);
          refreshButtonState(ajax);
        }
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            layoutPass('initial (aspect-ratio CSS)');
            trackAjaxHeight('after-results-render');
            dumpModalSpacing('after-results-render');
          });
        });
        var pending = 0;
        for (var n = 0; n < imgs.length; n += 1) {
          if (imgs[n].complete) continue;
          pending += 1;
          imgs[n].addEventListener('load', function () {
            pending -= 1;
            if (pending === 0) {
              layoutPass('all images loaded');
              trackAjaxHeight('after-images-loaded');
            }
          }, { once: true });
          imgs[n].addEventListener('error', function () {
            pending -= 1;
            if (pending === 0) {
              layoutPass('images settled (with errors)');
              trackAjaxHeight('after-images-error');
            }
          }, { once: true });
        }
      })
      .catch(function () {});
  }
  function positionButtons(ajax) {
    var slider = ajax.querySelector('.idm-search-slider');
    var prev = ajax.querySelector('.idm-search-slider__prev');
    var next = ajax.querySelector('.idm-search-slider__next');
    var firstImage = ajax.querySelector('.idm-search-slider__item .image-square');
    if (!slider || !prev || !next || !firstImage) {
      return;
    }
    var sliderRect = slider.getBoundingClientRect();
    var imageRect = firstImage.getBoundingClientRect();
    var imageMidY = (imageRect.top - sliderRect.top) + (imageRect.height / 2);
    var btnHeight = prev.offsetHeight || (window.innerWidth <= 768 ? 38 : 44);
    var topPx = Math.round(imageMidY - btnHeight / 2);
    prev.style.top = topPx + 'px';
    next.style.top = topPx + 'px';
  }
  function refreshButtonState(ajax) {
    var inner = ajax.querySelector('.idm-search-slider__inner');
    var prev = ajax.querySelector('.idm-search-slider__prev');
    var next = ajax.querySelector('.idm-search-slider__next');
    if (!inner || !prev || !next) {
      return;
    }
    var canScroll = inner.scrollWidth > inner.clientWidth + 2;
    if (!canScroll) {
      prev.hidden = true;
      next.hidden = true;
      prev.removeAttribute('aria-disabled');
      next.removeAttribute('aria-disabled');
      return;
    }
    prev.hidden = false;
    next.hidden = false;
    var atStart = inner.scrollLeft <= 1;
    var atEnd = inner.scrollLeft >= (inner.scrollWidth - inner.clientWidth - 1);
    prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
    next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
  }
  var SCROLL_DURATION_MS = 500;
  var scrollAnim = null;
  var scrollTargetLeft = null;
  function makeBezierEasing(p1x, p1y, p2x, p2y) {
    var ax = 3 * p1x - 3 * p2x + 1;
    var bx = -6 * p1x + 3 * p2x;
    var cx = 3 * p1x;
    var ay = 3 * p1y - 3 * p2y + 1;
    var by = -6 * p1y + 3 * p2y;
    var cy = 3 * p1y;
    function sampleX(t) { return ((ax * t + bx) * t + cx) * t; }
    function sampleY(t) { return ((ay * t + by) * t + cy) * t; }
    function sampleDX(t) { return (3 * ax * t + 2 * bx) * t + cx; }
    return function (x) {
      if (x <= 0) return 0;
      if (x >= 1) return 1;
      var t = x;
      for (var i = 0; i < 8; i += 1) {
        var diff = sampleX(t) - x;
        if (Math.abs(diff) < 0.0001) return sampleY(t);
        var d = sampleDX(t);
        if (Math.abs(d) < 1e-6) break;
        t = t - diff / d;
      }
      var lo = 0, hi = 1, mid;
      for (var j = 0; j < 20; j += 1) {
        mid = (lo + hi) / 2;
        if (sampleX(mid) > x) hi = mid; else lo = mid;
      }
      return sampleY((lo + hi) / 2);
    };
  }
  var easeCss = makeBezierEasing(0.25, 0.1, 0.25, 1.0);
  function smoothScroll(el, dx, onComplete) {
    var startLeft = el.scrollLeft;
    var maxLeft = el.scrollWidth - el.clientWidth;
    var baseLeft = (scrollTargetLeft !== null) ? scrollTargetLeft : startLeft;
    var target = Math.max(0, Math.min(baseLeft + dx, maxLeft));
    var change = target - startLeft;
    if (change === 0) {
      scrollTargetLeft = null;
      if (typeof onComplete === 'function') onComplete();
      return;
    }
    if (scrollAnim) cancelAnimationFrame(scrollAnim);
    scrollTargetLeft = target;
    var startTime = null;
    var prevSnap = el.style.scrollSnapType;
    el.style.scrollSnapType = 'none';
    function tick(now) {
      if (startTime === null) startTime = now;
      var progress = Math.min((now - startTime) / SCROLL_DURATION_MS, 1);
      el.scrollLeft = startLeft + change * easeCss(progress);
      if (progress < 1) {
        scrollAnim = requestAnimationFrame(tick);
      } else {
        scrollAnim = null;
        scrollTargetLeft = null;
        el.scrollLeft = target;
        el.style.scrollSnapType = prevSnap || '';
        if (typeof onComplete === 'function') onComplete();
      }
    }
    scrollAnim = requestAnimationFrame(tick);
  }
  function bindCarouselNav(ajax) {
    var inner = ajax.querySelector('.idm-search-slider__inner');
    var prev = ajax.querySelector('.idm-search-slider__prev');
    var next = ajax.querySelector('.idm-search-slider__next');
    if (!inner || !prev || !next) { return; }
    function step() {
      var item = inner.querySelector('.idm-search-slider__item');
      return item ? Math.round(item.offsetWidth + 20) : 240;
    }
    prev.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (prev.getAttribute('aria-disabled') === 'true') {
        return;
      }
      var s = step();
      smoothScroll(inner, -s, function () { refreshButtonState(ajax); });
    });
    next.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (next.getAttribute('aria-disabled') === 'true') {
        return;
      }
      var s = step();
      smoothScroll(inner, s, function () { refreshButtonState(ajax); });
    });
    inner.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () { refreshButtonState(ajax); });
    });
  }
  function showPreSuggest() {
    var ajax = getAjax();
    var input = getInput();
    if (!ajax) { return; }
    if (!input) { return; }
    var v = (input.value || '').trim();
    if (v !== '') {
      return;
    }
    if (preSuggestVisible) {
      return;
    }
    var parsed = parsePreSuggestTemplate();
    if (!parsed.fragment) {
      return;
    }
    if (!parsed.cards.length) {
      var preview = '';
      var t = document.getElementById('idm-pre-suggest-template');
      if (t) preview = (t.textContent || '').substring(0, 800);
      if (!idmPreSuggestLoaded) {
        idmLoadPreSuggest(function () { showPreSuggest(); });
      }
      return;
    }
    var rawCards = parsed.cards;
    var label = window.__IDM_SEARCH_PRE_SUGGEST_LABEL__ || '';
    var wrapper = document.createElement('div');
    wrapper.className = 'idm-pre-suggest';
    wrapper.innerHTML =
      (label ? '<h2 class="index-title idm-pre-suggest-title">' + escapeHtml(label) + '</h2>' : '')
      + '<div class="idm-search-slider">'
        + '<button class="idm-search-slider__prev" type="button" aria-label="' + ((window.__IDM_SEARCH_NAV_L__ || {}).prev || '') + '" hidden>'
          + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M 15.5 19 L 8.5 12 L 15.5 5"/></svg>'
        + '</button>'
        + '<button class="idm-search-slider__next" type="button" aria-label="' + ((window.__IDM_SEARCH_NAV_L__ || {}).next || '') + '" hidden>'
          + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M 8.5 19 L 15.5 12 L 8.5 5"/></svg>'
        + '</button>'
        + '<div class="idm-search-slider__nav"><div class="idm-search-slider__inner"></div></div>'
      + '</div>';
    var inner = wrapper.querySelector('.idm-search-slider__inner');
    for (var i = 0; i < rawCards.length; i += 1) {
      inner.appendChild(rawCards[i].cloneNode(true));
    }
    ajax.innerHTML = '';
    ajax.appendChild(wrapper);
    forceAjaxVisible();
    preSuggestVisible = true;
    if (idmPreSuggestImagesReady) { activateImages(wrapper); }
    bindCarouselNav(ajax);
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        positionButtons(ajax);
        refreshButtonState(ajax);
        trackAjaxHeight('after-pre-suggest');
      });
    });
  }
  function clearPreSuggest() {
    var ajax = getAjax();
    if (!ajax) return;
    var pre = ajax.querySelector('.idm-pre-suggest');
    if (pre) {
      if (ajax.children.length === 1 && ajax.firstElementChild === pre) {
        ajax.innerHTML = '';
      } else {
        pre.remove();
      }
    }
    preSuggestVisible = false;
  }
  var resizeTimer = null;
  function onWindowResize() {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var ajax = getAjax();
      if (!ajax) return;
      if (!ajax.querySelector('.idm-search-slider')) return;
      positionButtons(ajax);
      refreshButtonState(ajax);
    }, 100);
  }
  function syncModalToVisualViewport() {
    if (!window.visualViewport) return;
    var modalContent = document.querySelector('.modal-search .modal-search-content');
    if (!modalContent) return;
    var vh = window.visualViewport.height;
    var prev = modalContent.style.maxHeight;
    modalContent.style.maxHeight = vh + 'px';
    if (prev !== vh + 'px') {
    }
  }
  function init() {
    var ajax = getAjax();
    var input = getInput();
    if (!ajax || !input) {
      window.setTimeout(init, 200);
      return;
    }
    var clone = input.cloneNode(true);
    if (input.parentNode) {
      input.parentNode.replaceChild(clone, input);
      input = clone;
    }
    setKeyboardActive(true);
    function setKeyboardActive(active) {
      var modal = document.querySelector('.modal-search');
      if (!modal) return;
      if (active) modal.classList.add('idm-keyboard-active');
      else modal.classList.remove('idm-keyboard-active');
    }
    input.addEventListener('focus', function (e) {
      e.stopImmediatePropagation();
      setKeyboardActive(true);
      idmPreSuggestActivate();
      var v = (input.value || '').trim();
      if (v === '') showPreSuggest();
    }, true);
    var closeBtn = document.getElementById('close-search-bar');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        setKeyboardActive(false);
        unlockAjaxHeight();
        preSuggestVisible = false;
        lastRenderQuery = '';
      });
    }
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.keyCode === 27)
          && document.querySelector('.modal-search.idm-keyboard-active')) {
        setKeyboardActive(false);
        unlockAjaxHeight();
        preSuggestVisible = false;
        lastRenderQuery = '';
      }
    });
    input.addEventListener('input', function (e) {
      e.stopImmediatePropagation();
      var v = (input.value || '').trim();
      if (v === '') {
        lastQuery = '';
        lastRenderQuery = '';
        showPreSuggest();
      } else {
        trackAjaxHeight('before-input-clear');
        clearPreSuggest();
        if (lastRenderQuery !== v) showLoadingState();
        scheduleRender(v);
      }
    }, true);
    window.addEventListener('resize', onWindowResize);
    var guardTimer = null;
    var observer = new MutationObserver(function () {
      if (guardTimer) clearTimeout(guardTimer);
      guardTimer = setTimeout(function () {
        if (!lastRenderQuery) return;
        var v = ((input.value || '').trim());
        if (v !== lastRenderQuery) return;
        var ours = ajax.querySelector('.idm-search-slider')
          || ajax.querySelector('.idm-search-no-results')
          || ajax.querySelector('.idm-pre-suggest')
          || ajax.querySelector('.idm-search-pending');
        if (!ours) {
          lastRenderQuery = '';
          doRender(v);
        }
      }, 80);
    });
    observer.observe(ajax, { childList: true });
  }
  if (document.readyState === 'complete') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
